import { Box, Stack } from "@mui/material";
import { getSafeAreaPaddings } from "@src/appV2/redesign/utils/getSafeAreaPaddings";

import { getTaxSeasonInfo } from "../utils/getTaxSeasonInfo";
import { TaxationFaqs } from "./TaxationFaqs";
import { TaxInformationCard } from "./TaxInformationCard";
import { TaxPreparationSection } from "./TaxPreparationSection";

export function TaxInformationPageContent(props: {
  workerTimezone: string;
  taxationYear: number;
  earnedAmountInDollars: number;
  formIssuanceThresholdInDollars: number;
  scrollRef?: React.RefObject<HTMLDivElement>;
}) {
  const {
    workerTimezone,
    taxationYear,
    earnedAmountInDollars,
    formIssuanceThresholdInDollars,
    scrollRef,
  } = props;

  const { taxSeason } = getTaxSeasonInfo({ taxationYear, timezone: workerTimezone });

  const isEligibleToPayTax =
    taxSeason === "tax-filing" && earnedAmountInDollars >= formIssuanceThresholdInDollars;
  return (
    <Box
      ref={scrollRef}
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        overflowX: "hidden",
        flexGrow: 1,
        "&::-webkit-scrollbar": {
          display: "none",
        },
        ...getSafeAreaPaddings({
          bottom: true,
          fallbackBottom: theme.spacing(6),
          right: true,
          fallbackRight: theme.spacing(5),
          left: true,
          fallbackLeft: theme.spacing(5),
        }),
        paddingTop: theme.spacing(6),
      })}
    >
      <Stack direction="column" spacing={8}>
        <TaxInformationCard
          isEligibleToPayTax={isEligibleToPayTax}
          earnedAmountInDollars={earnedAmountInDollars}
          formIssuanceThresholdInDollars={formIssuanceThresholdInDollars}
        />

        <Stack direction="column" sx={{ paddingX: 1 }} spacing={8}>
          {taxSeason === "tax-preparation" && <TaxPreparationSection taxationYear={taxationYear} />}

          <TaxationFaqs
            isEligibleToPayTax={isEligibleToPayTax}
            title={taxSeason === "tax-preparation" ? "Questions?" : undefined}
            formIssuanceThresholdInDollars={formIssuanceThresholdInDollars}
            taxationYear={taxationYear}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
